import { useTranslation } from "@next-platform/client-common-core";
import { IconVariants, Input, Size, useMedia } from "@next-platform/client-common-spicy-ui";
import { useEffect, useState } from "react";
import { useDebounceValue } from "usehooks-ts";

const SEARCH_DEBOUNCE_MS = 300;
const SEARCH_BAR_DESKTOP_WIDTH = 400;

type MyChatbotsSearchBarProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
};

export default function MyChatbotsSearchBar({ value, onChange, placeholder }: MyChatbotsSearchBarProps) {
  const { t } = useTranslation();
  const { isMobile } = useMedia();
  const [stateLocalValue, setStateLocalValue] = useState(value);
  const [debouncedValue] = useDebounceValue(stateLocalValue, SEARCH_DEBOUNCE_MS);

  const resolvedPlaceholder = placeholder ?? t("search:placeholder");

  useEffect(() => {
    setStateLocalValue(value);
  }, [value]);

  useEffect(() => {
    onChange(debouncedValue);
  }, [debouncedValue, onChange]);

  const handleInputChange = (newValue: string) => {
    setStateLocalValue(newValue);
  };

  return (
    <Input
      value={stateLocalValue}
      iconStart={IconVariants.SEARCH}
      onClear={() => setStateLocalValue("")}
      isClearable={!!stateLocalValue}
      iconEnd={stateLocalValue ? IconVariants.CLOSE : undefined}
      placeholder={resolvedPlaceholder}
      onChange={handleInputChange}
      size={Size.SMALL}
      width={isMobile ? "100%" : SEARCH_BAR_DESKTOP_WIDTH}
    />
  );
}
